module.exports = __webpack_public_path__ + "img/device_1001_3.9480d621.svg";